import React, {Component, PropTypes} from 'react'
import {message, Button, Row, Col, Modal, Collapse, Icon} from 'antd'
const Panel = Collapse.Panel
import moment from 'moment'
import {getEducationName} from '../../config/education'
import {getacceptOfferStatus, getJobStatus, getInterviewResult, getChannelCode} from '../../config/recruitment'
import {API_ROOT} from '../../config'

const isTrue = (value) => {
  if(value || value === 0) {
    return true
  }
  return false
}
const getUserName = (uid, allUsers = []) => {
   const user = allUsers.find(item => item.uid == uid)
   return user ? user.realName : '-'
}
class Detail extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { visible, form, initialValues, onCancel, allUsers} = this.props
		const {
      needsPersonId,
      name,
      inviteDate,
      telphone,
      email,
      school,
      profession,
      education,
      graduationDate,
      jobExperience,
      famousEnterprises,
      channel,
      channelCode,
      inviteRequest,
      isAcceptOffer,
      isJob,
      preSalary,
      hopeSalary,
      resume,
      memo,
      interview = {},
      record = [],
      resumeInfo = {},
    } = initialValues
    const {
      isInterview,
      interviewDate,
      interviewStartTime,
      interviewEndTime,
      interviewResult,
    } = interview
    let fileName = ''
    if (resumeInfo) {
      fileName = <a href={`${resumeInfo.attachmentUrl}`} target="_blank">{`${resumeInfo.attachmentName}.${resumeInfo.attachmentType}`}</a>
    }
    const styles = {
      title: {
        textAlign: 'right',
        marginTop: 10
      },
      value: {
        textAlign: 'left',
        marginTop: 10
      }
    }
    const getHeader = (index) => {
      return (
        <div>
          <span>{`第${index + 1}轮面试记录`}</span>
        </div>
      )
    }
    return (
      <Modal
        visible={visible}
        title={`候选人详情`}
				maskClosable={true}
        footer={null}
        onCancel={onCancel}
      >
        <Row type="flex" justify="start" align="top" gutter={16}>
          <Col span={8}><div style={styles.title}>姓名:</div></Col>
          <Col span={16}><div style={styles.value}>{name}</div></Col>
           
          <Col span={8}><div style={styles.title}>手机号:</div></Col>
          <Col span={16}><div style={styles.value}>{telphone}</div></Col>
          <Col span={8}><div style={styles.title}>邮箱:</div></Col>
          <Col span={16}><div style={styles.value}>{email}</div></Col>
          <Col span={8}><div style={styles.title}>毕业学校:</div></Col>
          <Col span={16}><div style={styles.value}>{school}</div></Col>
          <Col span={8}><div style={styles.title}>毕业日期:</div></Col>
          <Col span={16}><div style={styles.value}>{graduationDate}</div></Col>
          <Col span={8}><div style={styles.title}>专业:</div></Col>
          <Col span={16}><div style={styles.value}>{profession}</div></Col>
          <Col span={8}><div style={styles.title}>学历:</div></Col>
          <Col span={16}><div style={styles.value}>{getEducationName(education)}</div></Col>
          <Col span={8}><div style={styles.title}>相关工作经验:</div></Col>
          <Col span={16}><div style={styles.value}>{jobExperience}</div></Col>
          <Col span={8}><div style={styles.title}>是否有名企经验:</div></Col>
          <Col span={16}><div style={styles.value}>{isTrue(famousEnterprises) ? '是' : '否' }</div></Col>
          <Col span={8}><div style={styles.title}>渠道:</div></Col>
          <Col span={16}><div style={styles.value}>{getChannelCode(channelCode)}</div></Col>
          <Col span={8}><div style={styles.title}>渠道备注:</div></Col>
          <Col span={16}><div style={styles.value}>{channel}</div></Col>
          <Col span={8}><div style={styles.title}>邀约记录:</div></Col>
          <Col span={16}><div style={styles.value}>{inviteRequest}</div></Col>
          <Col span={8}><div style={styles.title}>是否接受offer:</div></Col>
          <Col span={16}><div style={styles.value}>{getacceptOfferStatus(isAcceptOffer)}</div></Col>
          <Col span={8}><div style={styles.title}>入职状态:</div></Col>
          <Col span={16}><div style={styles.value}>{getJobStatus(isJob)}</div></Col>
          <Col span={8}><div style={styles.title}>上家公司薪资:</div></Col>
          <Col span={16}><div style={styles.value}>{preSalary}</div></Col>
          <Col span={8}><div style={styles.title}>期望薪资:</div></Col>
          <Col span={16}><div style={styles.value}>{hopeSalary}</div></Col>

          <Col span={8}><div style={styles.title}>简历:</div></Col>
          <Col span={16}><div style={styles.value}>{fileName}</div></Col>

          <Col span={8}><div style={styles.title}>备注:</div></Col>
          <Col span={16}><div style={styles.value}>{memo}</div></Col>

          <Col span={8}><div style={styles.title}>邀请面试日期:</div></Col>
          <Col span={16}><div style={styles.value}>{inviteDate ? inviteDate.slice(0, 10) : ''}</div></Col>

          <Col span={8}><div style={styles.title}>是否参加面试:</div></Col>
          <Col span={16}><div style={styles.value}>{isTrue(isInterview) ? '是' : '否' }</div></Col>
          {/* <Col span={8}><div style={styles.title}>面试时间:</div></Col>
          <Col span={16}><div style={styles.value}>{interviewDate}</div></Col> */}
          <Col span={8}><div style={styles.title}>面试开始时间:</div></Col>
          <Col span={16}><div style={styles.value}>{interviewStartTime}</div></Col>
          <Col span={8}><div style={styles.title}>面试结束时间:</div></Col>
          <Col span={16}><div style={styles.value}>{interviewEndTime}</div></Col>
          <Col span={8}><div style={styles.title}>面试结果:</div></Col>
          <Col span={16}><div style={styles.value}>{getInterviewResult(interviewResult)}</div></Col>

          {/* <Col span={8}><div style={styles.title}>面试记录:</div></Col> */}
          <Col span={24}>
            <div style={styles.value}>
              {
                (record.length && record.length > 0) ? (
                  <Collapse bordered={false} style={{margin: "30px 0"}} defaultActiveKey={record.length -1 + ''}>
                  {
                    record.map((item, index, arr) => {
                      return (
                        <Panel header={getHeader(index)} key={index + ''}>
                          <Row type="flex" justify="start" align="top" gutter={16}>
                            <Col span={8}><div style={styles.title}>面试官:</div></Col>
                            <Col span={16}><div style={styles.value}>{getUserName(item.interviewer, allUsers)}</div></Col>
                            <Col span={8}><div style={styles.title}>评价:</div></Col>
                            <Col span={16}><div style={styles.value}>{item.evaluation}</div></Col>
                            <Col span={8}><div style={styles.title}>面试结果:</div></Col>
                            <Col span={16}><div style={styles.value}>{getInterviewResult(item.interviewResult)}</div></Col>
                          </Row>
                        </Panel>
                      )
                    })
                  }
                  </Collapse>
                ) : '-'
              }
            </div>
          </Col>
        </Row>
      </Modal>
    )
  }
}

export default Detail


// WEBPACK FOOTER //
// ./src/components/recruitment/needPersonDetail.js